/**
 * 存放和bridge功能极为相关的处理方法
 */
import {
  inApp
} from './env';
import {
  ajax
} from './method';

/**
 * 获得对象版本的app version
 * @param version
 * @returns {*}
 */
export function getAppVersion(version) {
  var target = navigator.userAgent;

  if (typeof version === 'object') {
    return version;
  }

  if (typeof version === 'string') {
    target = 'didi.passenger/' + version;
  }

  version = (
    /didi\.passenger\/([\d.]+)/.test(target) ? RegExp.$1 : '0.0.0'
  ).split('.');

  switch (version.length) {
    case 1:
      version[1] = version[2] = 0;
      break;
    case 2:
      version[2] = 0;
      break;
  }

  return {
    main: version[0] - 0,
    sub: version[1] - 0,
    mini: version[2] - 0
  };
}

/**
 * 比较app版本大小(eval is harmful)
 * @param version1
 * @param operator
 * @param version2
 * @returns {Boolean}
 */
export function compareVersion(version1, operator, version2) {
  const v1 = _parseVersionToInt(version1);
  const v2 = _parseVersionToInt(version2);
  var operators = {
    '>': function (a, b) {
      return a > b;
    },
    '<': function (a, b) {
      return a < b;
    },
    '==': function (a, b) {
      return a === b;
    },
    '===': function (a, b) {
      return a === b;
    },
    '<=': function (a, b) {
      return a <= b;
    },
    '>=': function (a, b) {
      return a >= b;
    }
  };

  return operators[operator](v1, v2);
}

function _parseVersionToInt(version) {
  let num = 0;

  version = getAppVersion(version);
  num += version.main * 10000;
  num += version.sub * 100;
  num += version.mini * 1;
  return num;
}

/**
 * entrance分享配置兼容参数格式
 * @param opts
 */
export function entranceConfigAlias(opts) {
  if (opts && opts.buttons) {
    // 兼容两种button分享参数名写法
    let buttons = opts.buttons;
    buttons && buttons.forEach(function (item) {
      if (item) {
        btnShareConfigAlias(item);
      }
    });
  }
}

/**
 * entrance分享配置button兼容参数格式
 * @param data
 */
export function btnShareConfigAlias(button) {
  if (button.type) {
    // 统一转为新的type
    let buttonType = button.type;
    if (buttonType === 'page_refresh') {
      button.type = 'refreshPage';
    } else {
      button.type = buttonType.replace(/_(.)/g, function () {
        return arguments[1].toUpperCase();
      });
      // 即使是朋友圈分享大图也肯定至少写icon或img地址
      button.data = button.data || {};
      shareConfigAlias(button.data);
    }
  }
}

/**
 * shareConfig格式兼容
 * @param shareConfig
 */
export function shareConfigAlias(shareConfig) {
  if (shareConfig.icon || shareConfig.img) {
    shareConfig.share_title = shareConfig.title;
    shareConfig.share_content = shareConfig.content;
    shareConfig.share_url = shareConfig.url;
    shareConfig.share_icon_url = shareConfig.icon;
    shareConfig.share_img_url = shareConfig.img;
  } else if (shareConfig.share_icon_url || shareConfig.share_img_url) {
    shareConfig.title = shareConfig.share_title;
    shareConfig.content = shareConfig.share_content;
    shareConfig.url = shareConfig.share_url;
    shareConfig.icon = shareConfig.share_icon_url;
    shareConfig.img = shareConfig.share_img_url;
  }
}

/**
 * 模拟bridge在端外的返回值，以请求的形式在业务项目仓库进行模拟，如果是端内正常使用
 */
export function mockOrCall(DDbridge, method, opts, cb) {
  opts = opts || {};
  cb = cb || function () {};
  var lowercaseMethod = method.toLowerCase();
  if (!inApp()) {
    var mockUrl = '/beatles/bridge/api/' + lowercaseMethod;
    ajax({
      url: mockUrl,
      success: function (response) {
        if (response && response.errno === '0') {
          cb(response.data);
        }
      },
      error: function () {
        window.console.log('请在项目内mock该请求(在返回结构包括errno为字符串0和data，data里为bridge的结果)：' + mockUrl);
      }
    });
  } else {
    DDbridge.call(method, opts, cb);
  }
}



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridgebeatles/beatles/util/related.js